// extracted by mini-css-extract-plugin
export default {"FooterContainer":"Footer_FooterContainer__mL07u","LogoIcon":"Footer_LogoIcon__ne9xy","Icon":"Footer_Icon__F0QAX"};